import type { PropsWithChildren } from 'react';
import React from 'react';
import { usePlanCreationPlanPreview } from '../../../../../contexts/create-plan-context/CreatePlanProvider/hooks/use-plan-creation-plan-preview';
import { CreateCreditNoteContext } from './create-credit-note-context';

type CreateCreditNoteProviderProps = PropsWithChildren;

export function CreateCreditNoteProvider({ children }: CreateCreditNoteProviderProps) {
  const planPreview = usePlanCreationPlanPreview();

  return (
    <CreateCreditNoteContext.Provider
      value={{
        planPreview,
      }}
    >
      {children}
    </CreateCreditNoteContext.Provider>
  );
}

export function withCreateCreditNoteProvider(Component: React.FC) {
  return (props: CreateCreditNoteProviderProps) => {
    return (
      <CreateCreditNoteProvider {...props}>
        <Component />
      </CreateCreditNoteProvider>
    );
  };
}
